import React, { FC } from 'react';

import { Col, Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { FormattedMessage, useIntl } from 'react-intl';

export interface OwnProps {
  children?: React.ReactNode;
  form: FormInstance;
  modal?: boolean;
  className?: string;
}

type Props = OwnProps;

export const PharmacyZipCodeForm: FC<Props> = (props): JSX.Element => {
  const { children, form, className } = props;

  const { formatMessage } = useIntl();

  return (
    <Row align="middle" className={className}>
      <p className="zipCode-modal__subtitle">
        <FormattedMessage id="form.field.pharmacy.subtitle" />
      </p>
      <Col xs={24}>
        <Form
          form={form}
          layout="vertical"
          className="zipCode-form"
          validateMessages={{
            required: formatMessage({ id: 'field.required' }),
          }}
        >
          {children}
        </Form>
      </Col>
    </Row>
  );
};
